import { render, staticRenderFns } from "./EtapaIcon.vue?vue&type=template&id=12f7ae95&scoped=true&"
import script from "./EtapaIcon.vue?vue&type=script&lang=js&"
export * from "./EtapaIcon.vue?vue&type=script&lang=js&"
import style0 from "./EtapaIcon.vue?vue&type=style&index=0&id=12f7ae95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f7ae95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VImg,VLayout})
